import { ApolloError } from '@apollo/client';
import { AssignUnassignAssociatedCrewMembersError } from '@bechtel/types';

export type AssignUnassignAssociatedCrewMembersErrorType = AssignUnassignAssociatedCrewMembersError | ApolloError;

export interface AssignUnassignAssociatedCrewMembersErrorProps {
  error: AssignUnassignAssociatedCrewMembersErrorType;
  close: () => void;
}
